export const API_KEY = '93850022b4ef4d6cb81155237221402';

export const API_ENDPOINT = 'https://api.weatherapi.com/v1/';